enum DayOfWeek {
  FRIDAY = "friday",
  MONDAY = "monday",
  SATURDAY = "saturday",
  SUNDAY = "sunday",
  THURSDAY = "thursday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
}

export default DayOfWeek;
